module.exports = __webpack_public_path__ + "static/assets/faef218a10693525eaa087f8c26fe2aa.png";